import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
export function SalesPage() {
  useEffect(() => {
    // Meta Pixel Code
    const script1 = document.createElement('script');
    script1.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '858034503518320');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script1);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=858034503518320&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script1);
      document.body.removeChild(noscript);
    };
  }, []);
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className="min-h-screen w-full bg-white" data-id="element-30">
      <CountdownTimer data-id="element-31" />
      <PurchaseNotification data-id="element-32" />

      {/* Hero Section */}
      <section className="pt-12 pb-6 px-4 bg-white" data-id="element-33">
        <div className="max-w-5xl mx-auto text-center" data-id="element-34">
          <h1 className="text-lg md:text-2xl lg:text-3xl text-gray-900 mb-4 leading-tight" data-id="element-35">
            🌿 Para mujeres que funcionan… aunque estén agotadas por dentro
          </h1>

          <div className="mb-4" data-id="element-36">
            <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-37">
              MegaPack
              <br data-id="element-38" />
              CANSANCIO INVISIBLE
            </p>
          </div>

          <p className="text-base md:text-lg text-gray-700 font-bold mb-4" data-id="element-39">
            Alivio mental hoy, sin cambiar tu vida
          </p>

          <p className="text-sm md:text-base text-gray-600 mb-6 max-w-3xl mx-auto" data-id="element-40">
            Un sistema de alivio mental para mujeres que no pueden frenar… pero
            ya no pueden seguir igual.
          </p>

          {/* Main Product Image - Clickable to scroll to purchase */}
          <div className="mb-4" data-id="element-41">
            <a href="#purchase-section" onClick={scrollToPurchase} className="inline-block hover:scale-105 transition-transform duration-200 cursor-pointer" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/aiE44P5Cvj7EnhYgCtGuY4/Incluye_3_bonos_especiales_(5).png" alt="MegaPack Cansancio Invisible - Incluye 3 bonos gratis" className="w-full max-w-md mx-auto rounded-lg shadow-2xl" style={{
              maxWidth: '400px'
            }} data-id="element-43" />
            </a>
          </div>

          <div className="flex justify-center" data-id="element-44">
            <CTAButton data-id="element-45">👉 SÍ, QUIERO SENTIR ALIVIO AHORA</CTAButton>
          </div>

          <p className="text-sm text-gray-600 mt-4" data-id="element-46">
            ✅ Garantía de satisfacción de 7 días
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-47">
        <div className="max-w-4xl mx-auto" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-49">
            Si seguís funcionando… dejame hacerte una pregunta honesta
          </h2>

          <div className="bg-white p-8 rounded-lg shadow-lg mb-8" data-id="element-50">
            <p className="text-xl md:text-2xl text-gray-800 font-bold mb-6" data-id="element-51">
              ¿Te pasa que estás cansada… pero no sabés explicar exactamente de
              qué?
            </p>

            <div className="space-y-4 text-lg text-gray-700" data-id="element-52">
              <p data-id="element-53">
                Dormís. Seguís con tu vida. Cumplís tus responsabilidades. Te
                ocupás de todo.
              </p>
              <p className="font-bold" data-id="element-54">Y sin embargo…</p>
              <p data-id="element-55">
                La mente no para. La lista mental nunca termina. La exigencia no
                descansa.
              </p>
              <p className="font-bold text-xl" data-id="element-56">
                Y lo peor es que encima pensás:
              </p>
              <p className="text-2xl font-black text-red-600" data-id="element-57">
                "¿Por qué estoy así si no debería estarlo?"
              </p>
            </div>
          </div>

          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg" data-id="element-58">
            <p className="text-lg text-gray-800 mb-2" data-id="element-59">
              No es falta de fuerza. No es debilidad. No es que no puedas.
            </p>
            <p className="text-2xl font-black text-gray-900" data-id="element-60">
              Es cansancio invisible.
            </p>
          </div>
        </div>
      </section>

      {/* Problem Agitation */}
      <section className="py-16 px-4 bg-white" data-id="element-61">
        <div className="max-w-4xl mx-auto" data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center" data-id="element-63">
            El problema que nadie ve (pero vos sentís todos los días)
          </h2>

          <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-64">
            Si esto te suena familiar, probablemente estés viviendo:
          </p>

          <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-65">
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-66">
              <p className="text-gray-800 font-semibold" data-id="element-67">
                Mente que no se apaga ni cuando descansás
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-68">
              <p className="text-gray-800 font-semibold" data-id="element-69">
                Sensación constante de estar sosteniendo todo
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-70">
              <p className="text-gray-800 font-semibold" data-id="element-71">
                Culpa por no poder más
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-72">
              <p className="text-gray-800 font-semibold" data-id="element-73">
                Duda interna sobre si tu cansancio es válido
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-74">
              <p className="text-gray-800 font-semibold" data-id="element-75">
                Hiperresponsabilidad silenciosa
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-red-500" data-id="element-76">
              <p className="text-gray-800 font-semibold" data-id="element-77">
                Funcionar bien por fuera… estar agotada por dentro
              </p>
            </div>
          </div>

          <div className="bg-red-50 border-2 border-red-300 p-8 rounded-lg text-center" data-id="element-78">
            <p className="text-xl text-gray-800 mb-2" data-id="element-79">
              Lo más confuso es esto:
            </p>
            <p className="text-3xl font-black text-red-600 mb-4" data-id="element-80">
              "En teoría estoy bien."
            </p>
            <p className="text-lg text-gray-700" data-id="element-81">
              Y esa contradicción agota más que todo lo demás.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 px-4 bg-white border-y-2 border-gray-200" data-id="element-82">
        <div className="max-w-4xl mx-auto text-center" data-id="element-83">
          <CTAButton variant="secondary" data-id="element-84">
            QUIERO ALIVIAR MI CANSANCIO AHORA
          </CTAButton>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 px-4 bg-white" data-id="element-85">
        <div className="max-w-4xl mx-auto" data-id="element-86">
          <div className="text-center mb-12" data-id="element-87">
            <div className="inline-block bg-green-500 text-white px-6 py-3 rounded-lg mb-6" data-id="element-88">
              <p className="text-2xl font-black" data-id="element-89">✅ LA SOLUCIÓN</p>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-90">
              MegaPack Cansancio Invisible
            </h2>
            <p className="text-xl text-gray-700" data-id="element-91">
              Un sistema completo de alivio mental diseñado específicamente para
              mujeres que:
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-92">
            <span className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full font-bold text-lg" data-id="element-93">
              ✔ Funcionan
            </span>
            <span className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full font-bold text-lg" data-id="element-94">
              ✔ Cumplen
            </span>
            <span className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full font-bold text-lg" data-id="element-95">
              ✔ Sostienen
            </span>
            <span className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full font-bold text-lg" data-id="element-96">
              ✔ Pero están exhaustas por dentro
            </span>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg mb-8" data-id="element-97">
            <p className="text-lg text-gray-700 mb-4" data-id="element-98">
              No es un libro de productividad. No es un curso para exigirte más.
              No es una transformación forzada.
            </p>
            <p className="text-2xl font-black text-gray-900" data-id="element-99">
              Es un refugio estructurado.
            </p>
          </div>

          <div className="bg-blue-50 border-2 border-blue-500 p-8 rounded-lg" data-id="element-100">
            <h3 className="text-2xl font-black text-gray-900 mb-6 text-center" data-id="element-101">
              Cómo funciona (simple, sin presión)
            </h3>
            <div className="space-y-4 text-lg text-gray-800" data-id="element-102">
              <p data-id="element-103">📖 Abrís una página</p>
              <p data-id="element-104">🧠 Leés lo que necesitás hoy</p>
              <p data-id="element-105">🌿 Bajás la intensidad interna</p>
              <p className="font-bold mt-6" data-id="element-106">
                Sin terminarlo. Sin hacerlo "bien". Sin agregar tareas nuevas.
              </p>
              <p className="text-2xl font-black text-center mt-4" data-id="element-107">
                Solo alivio.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-108">
        <div className="max-w-4xl mx-auto" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-12 text-center" data-id="element-110">
            📘 ¿Qué incluye exactamente el MegaPack?
          </h2>

          <div className="bg-white p-8 rounded-lg shadow-lg mb-8" data-id="element-111">
            <h3 className="text-2xl font-black text-gray-900 mb-6" data-id="element-112">
              1️⃣ Ebook principal: Cansancio Invisible
            </h3>
            <div className="space-y-3" data-id="element-113">
              <div className="flex items-start gap-3" data-id="element-114">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-115" />
                <p className="text-gray-700" data-id="element-116">
                  Qué es el cansancio mental que no se ve
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-117">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-118" />
                <p className="text-gray-700" data-id="element-119">Por qué descansar no alcanza</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-120">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-121" />
                <p className="text-gray-700" data-id="element-122">La carga invisible que sostenés</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-123">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-124" />
                <p className="text-gray-700" data-id="element-125">
                  La hiperresponsabilidad silenciosa
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-126">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-127" />
                <p className="text-gray-700" data-id="element-128">Por qué no es tu culpa</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-129">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-130" />
                <p className="text-gray-700" data-id="element-131">
                  Cómo bajar la autoexigencia sin abandonar tu vida
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-white" data-id="element-132">
        <div className="max-w-5xl mx-auto" data-id="element-133">
          <div className="text-center mb-12" data-id="element-134">
            <div className="inline-block bg-yellow-400 text-gray-900 px-8 py-4 rounded-lg mb-4 animate-pulse" data-id="element-135">
              <p className="text-2xl md:text-3xl font-black" data-id="element-136">
                🎁 BONOS INCLUIDOS HOY
              </p>
            </div>
            <p className="text-xl text-gray-600" data-id="element-137">(Sin costo adicional)</p>
          </div>

          {/* Bono 1 */}
          <div className="bg-gradient-to-r from-red-50 to-orange-50 p-8 rounded-lg shadow-lg mb-8 border-2 border-red-200" data-id="element-138">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-139">
              <div data-id="element-140">
                <a href="#purchase-section" onClick={scrollToPurchase} className="block hover:scale-105 transition-transform duration-200 cursor-pointer" data-id="element-141">
                  <img src="https://cdn.magicpatterns.com/uploads/qbPSUnV82oVTtjSCMtrwfD/2.png" alt="Bono #1 - Cuando el cansancio invisible se hace ruido" className="w-full rounded-lg shadow-xl" style={{
                  maxWidth: '400px',
                  margin: '0 auto'
                }} data-id="element-142" />
                </a>
              </div>
              <div data-id="element-143">
                <div className="inline-block bg-yellow-400 text-gray-900 px-4 py-2 rounded-lg mb-4" data-id="element-144">
                  <p className="font-black" data-id="element-145">GRATIS HOY</p>
                </div>
                <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-146">
                  🎁 Bono #1 – Cuando el cansancio invisible se hace ruido
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-147">
                  <span className="line-through" data-id="element-148">Valor: ARS $19.990</span>
                  <span className="text-blue-600 font-bold ml-2" data-id="element-149">
                    HOY: GRATIS
                  </span>
                </p>
                <p className="text-gray-700 mb-4" data-id="element-150">
                  Para los días en que la cabeza no para.
                </p>
                <div className="space-y-2" data-id="element-151">
                  <div className="flex items-start gap-2" data-id="element-152">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-153" />
                    <p className="text-gray-700" data-id="element-154">
                      Ancla simple para volver al presente
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-155">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-156" />
                    <p className="text-gray-700" data-id="element-157">
                      Mini descarga mental en 3 minutos
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-158">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-159" />
                    <p className="text-gray-700" data-id="element-160">
                      Permiso para bajar el estándar
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-161">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-162" />
                    <p className="text-gray-700" data-id="element-163">
                      Herramientas para colapso emocional
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-164">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-165" />
                    <p className="text-gray-700" data-id="element-166">
                      Recursos usables incluso sin energía
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-lg shadow-lg mb-8 border-2 border-blue-200" data-id="element-167">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-168">
              <div className="order-2 md:order-1" data-id="element-169">
                <div className="inline-block bg-yellow-400 text-gray-900 px-4 py-2 rounded-lg mb-4" data-id="element-170">
                  <p className="font-black" data-id="element-171">GRATIS HOY</p>
                </div>
                <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-172">
                  🎁 Bono #2 – No estás fallando
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-173">
                  <span className="line-through" data-id="element-174">Valor: ARS $15.990</span>
                  <span className="text-blue-600 font-bold ml-2" data-id="element-175">
                    HOY: GRATIS
                  </span>
                </p>
                <p className="text-gray-700 mb-4" data-id="element-176">
                  Para los días de culpa y autoexigencia.
                </p>
                <div className="space-y-2" data-id="element-177">
                  <div className="flex items-start gap-2" data-id="element-178">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-179" />
                    <p className="text-gray-700" data-id="element-180">Desarme de la culpa cansada</p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-181">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-182" />
                    <p className="text-gray-700" data-id="element-183">Validación profunda</p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-184">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-185" />
                    <p className="text-gray-700" data-id="element-186">Reconocimiento de límites</p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-187">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-188" />
                    <p className="text-gray-700" data-id="element-189">
                      Permiso para soltar la idea de "poder con todo"
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-190">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-191" />
                    <p className="text-gray-700" data-id="element-192">
                      Recordatorios que alivian la dureza interna
                    </p>
                  </div>
                </div>
              </div>
              <div className="order-1 md:order-2" data-id="element-193">
                <a href="#purchase-section" onClick={scrollToPurchase} className="block hover:scale-105 transition-transform duration-200 cursor-pointer" data-id="element-194">
                  <img src="https://cdn.magicpatterns.com/uploads/9dgZ5tYVQWydWCBVkW1T27/3.png" alt="Bono #2 - No estás fallando" className="w-full rounded-lg shadow-xl" style={{
                  maxWidth: '400px',
                  margin: '0 auto'
                }} data-id="element-195" />
                </a>
              </div>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-8 rounded-lg shadow-lg mb-8 border-2 border-purple-200" data-id="element-196">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-197">
              <div data-id="element-198">
                <a href="#purchase-section" onClick={scrollToPurchase} className="block hover:scale-105 transition-transform duration-200 cursor-pointer" data-id="element-199">
                  <img src="https://cdn.magicpatterns.com/uploads/fKtmh3q5mhkhyT1SMaPGCP/4.png" alt="Bono #3 - Cómo usar este ebook cuando no tenés energía" className="w-full rounded-lg shadow-xl" style={{
                  maxWidth: '400px',
                  margin: '0 auto'
                }} data-id="element-200" />
                </a>
              </div>
              <div data-id="element-201">
                <div className="inline-block bg-yellow-400 text-gray-900 px-4 py-2 rounded-lg mb-4" data-id="element-202">
                  <p className="font-black" data-id="element-203">GRATIS HOY</p>
                </div>
                <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-204">
                  🎁 Bono #3 – Cómo usar este ebook cuando no tenés energía
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-205">
                  <span className="line-through" data-id="element-206">Valor: ARS $12.990</span>
                  <span className="text-blue-600 font-bold ml-2" data-id="element-207">
                    HOY: GRATIS
                  </span>
                </p>
                <p className="text-gray-700 mb-4" data-id="element-208">
                  Porque incluso leer puede sentirse como demasiado.
                </p>
                <div className="space-y-2" data-id="element-209">
                  <div className="flex items-start gap-2" data-id="element-210">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-211" />
                    <p className="text-gray-700" data-id="element-212">
                      Cómo usarlo en días de ruido mental
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-213">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-214" />
                    <p className="text-gray-700" data-id="element-215">
                      Cómo usarlo en culpa intensa
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-216">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-217" />
                    <p className="text-gray-700" data-id="element-218">
                      Cómo usarlo en agotamiento físico profundo
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-219">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-220" />
                    <p className="text-gray-700" data-id="element-221">
                      Permiso explícito para no terminarlo
                    </p>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-222">
                    <CheckIcon className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-223" />
                    <p className="text-gray-700" data-id="element-224">
                      Guía para usar solo una página
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Before/After Comparison */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-225">
        <div className="max-w-5xl mx-auto" data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-12 text-center" data-id="element-227">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-228">
            <div className="bg-white p-8 rounded-lg shadow-lg border-t-4 border-red-500" data-id="element-229">
              <h3 className="text-2xl font-black text-red-600 mb-6 text-center" data-id="element-230">
                Antes de Cansancio Invisible
              </h3>
              <div className="space-y-4" data-id="element-231">
                <div className="flex items-start gap-3" data-id="element-232">
                  <span className="text-red-500 text-xl" data-id="element-233">✗</span>
                  <p className="text-gray-700" data-id="element-234">
                    Te exigís más de lo que podés dar
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-235">
                  <span className="text-red-500 text-xl" data-id="element-236">✗</span>
                  <p className="text-gray-700" data-id="element-237">
                    Sentís culpa por estar cansada
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-238">
                  <span className="text-red-500 text-xl" data-id="element-239">✗</span>
                  <p className="text-gray-700" data-id="element-240">Dudás de vos misma</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-241">
                  <span className="text-red-500 text-xl" data-id="element-242">✗</span>
                  <p className="text-gray-700" data-id="element-243">Pensás que es debilidad</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-244">
                  <span className="text-red-500 text-xl" data-id="element-245">✗</span>
                  <p className="text-gray-700" data-id="element-246">La mente no para</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg border-t-4 border-blue-500" data-id="element-247">
              <h3 className="text-2xl font-black text-blue-600 mb-6 text-center" data-id="element-248">
                Después de Cansancio Invisible
              </h3>
              <div className="space-y-4" data-id="element-249">
                <div className="flex items-start gap-3" data-id="element-250">
                  <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-251" />
                  <p className="text-gray-700" data-id="element-252">Entendés lo que te pasa</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-253">
                  <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-254" />
                  <p className="text-gray-700" data-id="element-255">
                    Dejás de pelearte con tu cansancio
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-256">
                  <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-257" />
                  <p className="text-gray-700" data-id="element-258">Bajás la exigencia interna</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-259">
                  <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-260" />
                  <p className="text-gray-700" data-id="element-261">Validás tus límites</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-262">
                  <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-263" />
                  <p className="text-gray-700" data-id="element-264">Sentís alivio mental real</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8" data-id="element-265">
            <p className="text-xl font-bold text-gray-800" data-id="element-266">
              No cambia tu vida. Cambia cómo la sostenés.
            </p>
          </div>
        </div>
      </section>

      {/* What You'll Receive */}
      <section className="py-16 px-4 bg-white" data-id="element-267">
        <div className="max-w-4xl mx-auto" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-12 text-center" data-id="element-269">
            📦 Lo que vas a recibir hoy
          </h2>

          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-lg shadow-lg border-2 border-blue-300" data-id="element-270">
            <div className="space-y-4" data-id="element-271">
              <div className="flex items-start gap-3" data-id="element-272">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-273" />
                <p className="text-lg text-gray-800" data-id="element-274">
                  Ebook completo Cansancio Invisible
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-275">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-276" />
                <p className="text-lg text-gray-800" data-id="element-277">
                  Bono #1 – Cuando el cansancio invisible se hace ruido
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-278">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-279" />
                <p className="text-lg text-gray-800" data-id="element-280">
                  Bono #2 – No estás fallando
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-281">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-282" />
                <p className="text-lg text-gray-800" data-id="element-283">
                  Bono #3 – Cómo usar este ebook cuando no tenés energía
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-284">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-285" />
                <p className="text-lg text-gray-800" data-id="element-286">Acceso inmediato</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-287">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-288" />
                <p className="text-lg text-gray-800" data-id="element-289">Descarga digital</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-290">
                <CheckIcon className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-291" />
                <p className="text-lg text-gray-800" data-id="element-292">Acceso de por vida</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase-section" className="py-20 px-4 bg-gradient-to-b from-red-600 to-red-700" data-id="element-293">
        <div className="max-w-4xl mx-auto" data-id="element-294">
          {/* Título principal */}
          <div className="text-center mb-8" data-id="element-295">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 leading-tight" data-id="element-296">
              ⏰ OFERTA POR TIEMPO LIMITADO
            </h2>
            <p className="text-xl md:text-2xl text-yellow-300 font-bold" data-id="element-297">
              Esta oferta expira pronto. No la dejes pasar.
            </p>
          </div>

          {/* Card de precio */}
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-2xl border-4 border-yellow-400" data-id="element-298">
            <div className="text-center mb-8" data-id="element-299">
              <p className="text-xl md:text-2xl text-gray-600 mb-2" data-id="element-300">
                Precio regular:{' '}
                <span className="line-through font-bold" data-id="element-301">ARS $49.990</span>
              </p>
              <p className="text-2xl md:text-3xl text-gray-700 font-bold mb-4" data-id="element-302">
                HOY SOLO:
              </p>
              <p className="text-6xl md:text-7xl lg:text-8xl font-black text-green-600 mb-6" data-id="element-303">
                ARS $19.990
              </p>
              <div className="inline-block bg-red-100 border-2 border-red-500 px-6 py-3 rounded-lg" data-id="element-304">
                <p className="text-red-700 font-black text-lg md:text-xl" data-id="element-305">
                  ¡AHORRÁS ARS $30.000!
                </p>
              </div>
            </div>

            <div className="space-y-3 mb-8" data-id="element-306">
              <div className="flex items-center justify-center gap-3" data-id="element-307">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" aria-hidden="true" data-id="element-308" />
                <p className="text-lg md:text-xl text-gray-800 font-semibold" data-id="element-309">
                  Un solo pago
                </p>
              </div>
              <div className="flex items-center justify-center gap-3" data-id="element-310">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" aria-hidden="true" data-id="element-311" />
                <p className="text-lg md:text-xl text-gray-800 font-semibold" data-id="element-312">
                  Sin suscripciones
                </p>
              </div>
              <div className="flex items-center justify-center gap-3" data-id="element-313">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" aria-hidden="true" data-id="element-314" />
                <p className="text-lg md:text-xl text-gray-800 font-semibold" data-id="element-315">
                  Acceso inmediato
                </p>
              </div>
              <div className="flex items-center justify-center gap-3" data-id="element-316">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0" aria-hidden="true" data-id="element-317" />
                <p className="text-lg md:text-xl text-gray-800 font-semibold" data-id="element-318">
                  Incluye 3 bonos gratis
                </p>
              </div>
            </div>

            <div className="flex justify-center mb-6" data-id="element-319">
              <CTAButton isPurchaseButton={true} size="large" data-id="element-320">
                👉 OBTENER MI MEGAPACK AHORA
              </CTAButton>
            </div>

            <div className="text-center" data-id="element-321">
              <p className="text-sm text-gray-600" data-id="element-322">
                🔒 Pago seguro • ✅ Garantía de 7 días • 💳 Todos los medios de
                pago
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-323">
        <div className="max-w-3xl mx-auto" data-id="element-324">
          <div className="bg-white p-8 rounded-lg shadow-lg border-2 border-blue-300" data-id="element-325">
            <div className="flex items-center justify-center mb-6" data-id="element-326">
              <ShieldCheckIcon className="w-16 h-16 text-blue-500" aria-hidden="true" data-id="element-327" />
            </div>
            <h2 className="text-3xl font-black text-gray-900 mb-6 text-center" data-id="element-328">
              Garantía sin riesgo
            </h2>
            <p className="text-lg text-gray-700 text-center mb-4" data-id="element-329">
              Probalo durante 7 días.
            </p>
            <p className="text-xl text-gray-800 text-center mb-4" data-id="element-330">
              Si no sentís que te ayudó a bajar aunque sea un poco la presión
              interna, te devolvemos el 100% del dinero.
            </p>
            <p className="text-lg font-bold text-gray-900 text-center" data-id="element-331">
              Sin preguntas.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 px-4 bg-white" data-id="element-332">
        <div className="max-w-6xl mx-auto" data-id="element-333">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-12 text-center" data-id="element-334">
            Lo que dicen otras mujeres
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-335">
            <TestimonialCard name="Mariana" age={38} quote="Pensé que estaba exagerando. Este ebook me hizo entender que no estoy rota." location="Buenos Aires, Argentina" data-id="element-336" />
            <TestimonialCard name="Laura" age={41} quote="No me dio más cosas para hacer. Me dio permiso para soltar." location="Córdoba, Argentina" data-id="element-337" />
            <TestimonialCard name="Sofía" age={35} quote="Fue la primera vez que alguien puso en palabras exactamente lo que siento." location="Rosario, Argentina" data-id="element-338" />
            <TestimonialCard name="Carolina" age={39} quote="Finalmente entendí que mi cansancio es real y válido. Ya no me siento culpable por necesitar descanso." location="Mendoza, Argentina" data-id="element-339" />
            <TestimonialCard name="Valeria" age={37} quote="Este libro llegó justo cuando más lo necesitaba. Me ayudó a bajar la autoexigencia sin sentir que estoy fallando." location="La Plata, Argentina" data-id="element-340" />
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 px-4 bg-black text-white" data-id="element-341">
        <div className="max-w-4xl mx-auto text-center" data-id="element-342">
          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-343">
            Estar cansada no es fallar.
          </h2>

          <p className="text-xl mb-4" data-id="element-344">
            No es debilidad. No es exageración. No es falta de gratitud.
          </p>

          <p className="text-2xl font-bold mb-8" data-id="element-345">Es carga sostenida.</p>

          <p className="text-xl mb-12" data-id="element-346">Y podés empezar a aliviarla hoy.</p>

          <div className="flex justify-center" data-id="element-347">
            <CTAButton isPurchaseButton={true} data-id="element-348">
              👉 Accedé ahora a Cansancio Invisible
            </CTAButton>
          </div>

          <p className="text-lg mt-6 text-gray-300" data-id="element-349">
            Alivio mental hoy, sin cambiar tu vida.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 bg-gray-900 text-gray-400 text-center" data-id="element-350">
        <p className="text-sm" data-id="element-351">
          © 2026 Cansancio Invisible. Todos los derechos reservados.
        </p>
      </footer>
    </div>;
}